export default "__VITE_ASSET__d005f260__"